import { render } from "./ClientsSource.vue?vue&type=template&id=188ebe6c"
import script from "./ClientsSource.vue?vue&type=script&lang=js"
export * from "./ClientsSource.vue?vue&type=script&lang=js"

import "./ClientsSource.vue?vue&type=style&index=0&id=188ebe6c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__